import type { SVGProps } from "react";

const IconSave = (props: SVGProps<SVGSVGElement>) => (
  <svg  width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M22.4971 15.014V5.96484H18.0081V2.96484H6.00814V5.96484H1.47949V17.9875H6.00064V20.9875H18.0006V17.9875H21.6271L22.4971 16.4875H18.0006V15.0001L19.5006 14.9875V13.4875H4.49713V14.9875H6.00064V16.4875H2.97949V7.46484H20.9971V15.014H22.4971ZM7.49268 14.9964H16.5013L16.5006 19.5001H7.49268V14.9964ZM16.5081 5.96484H7.50814V4.46484H16.5081V5.96484ZM14.9918 18.0001H9.00064V16.5001H14.9918V18.0001ZM19.5037 10.4126H14.9076V8.9126H19.5037V10.4126Z" fill="currentColor" />
  </svg>

);

export default IconSave;
